// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const workerSchema = z.object({
  id: z.string().max(100),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500),
  status: z.string().max(20),
  lastHeartbeat: z.string().max(200).datetime(),
  currentExecutionId: z.string().max(100).optional(),
  capabilities: z.array(z.string()),
  mode: z.string().max(20),
  hostname: z.string().max(200),
  ip: z.string().max(200).optional(),
  healthPort: z.number().int().min(0).max(65535).optional(),
  maxConcurrent: z.number().int().min(1).max(1000),
  pollIntervalMs: z.number().int().min(100).max(3600000),
  registeredAt: z.string().max(200).datetime(),
  registeredBy: z.string().max(200),
  version: z.string().max(200).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  tenantId: z.string().max(100).optional(),
})

export type WorkerInput = z.infer<typeof workerSchema>
